import ToolLinksContainer from '../containers/ToolLinksContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolLinksCardContent = ({
  threadId
}) => {
  return /*#__PURE__*/_jsx(ToolLinksContainer, {
    threadId: threadId
  });
};
export const ToolLinksCardTitle = () => {
  return 'Tools';
};